var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "打印面单",
        visible: _vm.dialogVisible,
        width: "500px",
        "before-close": _vm.hide,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "100px",
            "label-suffix": "：",
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 22 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "打印任务数", prop: "num" } },
                    [_vm._v(_vm._s(_vm.form.printDatas.length))]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 18 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "打印机", prop: "print" } },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.form.printOptions,
                          clearable: false,
                        },
                        model: {
                          value: _vm.form.print,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "print", $$v)
                          },
                          expression: "form.print",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.hide } }, [
            _vm._v(_vm._s(_vm.$t("cancelText"))),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onConfirm } },
            [_vm._v("继续打印")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }